import { render, staticRenderFns } from "./home-news.vue?vue&type=template&id=39e1a5b1"
import script from "./home-news.vue?vue&type=script&lang=js"
export * from "./home-news.vue?vue&type=script&lang=js"
import style0 from "./home-news.vue?vue&type=style&index=0&id=39e1a5b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports